<template>
 <div class="selected-wrapper">
    <div class="selected-heading">You Have Selected:</div>
    <div class="selected-value" v-for="(key, index) in Object.keys(productProperties)" :key="`product-attr--${index}`">
      {{key}}: {{productProperties[key]}}
    </div>
 </div>
</template>
<script>
export default {
  name: "ProductDetails",
  props: {
    activeProduct: Object,
    productAttributes: Object,
    productType: String,
    fabrics: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      depthSizeProducts: ["Desk"],
    };
  },
  computed: {
    productProperties() {
      const propertyObject = {};
      const propertyKeys = [
        "cushion",
        "leg",
        "orientation",
        "chair_base",
        "bed_size",
        "chair_size",
        "drawer",
      ];
      // Enter these in the proper order of the field
      const productTypeSizeMapping = {
        Chair: ["width_1", "depth_size"],
        Chaise: ["chaise_width", "chaise_length"],
        Pillows: ["pillow_size"],
        Sectional: ["width_1", "width_2"],
        Desk: ["width_1", "depth_size"],
        Ottoman: ["width_1", "depth_size"],
        Loveseat: ["width_1"],
        "Modular Piece": ["width_1", "depth_size"],
        "Modular Sectional": ["width_1", "width_2", "width_3"],
        "Sectional with Bumper": ["width_1", "width_2"],
        "Sofa Bed": ["width_1"],
        "Sofa with Bumper": ["width_1"],
        "Sofa with Chaise": ["width_1", "chaise_width", "chaise_length"],
        "U-Shaped Sectional With Bumpers": ["width_2", "width_1"],
        "U-Shaped Sectional": ["width_2", "width_1"],
        "Double Chaise Sectional": ["width_2", "chaise_width", "chaise_length"],
        "U-Shaped Sectional With Chaise": ["width_1", "width_2", "width_3"],
        "Sectional With Chaise": ["width_1", "width_2", "width_3"],
      };
      if (productTypeSizeMapping[this.productType]) {
        propertyObject["Size"] = this.deriveSizeField(
          productTypeSizeMapping[this.productType]
        );
      }

      if (this.activeProduct.fabric) {
        const matchingFabric = this.fabrics.find((fabric) => fabric.title === this.productAttributes["fabric_color"])
        if (matchingFabric && matchingFabric.backorder_date) {
          const backInStockString = ` * Back In Stock ${new Date(matchingFabric.backorder_date).toLocaleDateString('en-US',{timeZone: "UTC", year: '2-digit', month: '2-digit', day:'2-digit'})}`
          propertyObject['Fabric'] = [this.activeProduct.fabric, this.productAttributes["fabric_color"], backInStockString].join(' ')
        
        } else {
          propertyObject['Fabric'] = [this.activeProduct.fabric, this.productAttributes["fabric_color"]].join(' ')
        }
        
      }

      for (const key of propertyKeys) {
        let value = "";
        if (this.activeProduct[key]) {
          value = this.activeProduct[key];
        } else if (this.productAttributes[key]) {
          value = this.productAttributes[key];
        }
        if (value) {
          const formattedKey = this.transformText(key);
          if (formattedKey === "Frame Code" && value.includes("|")) {
            value.split("|").forEach((frameCode, index) => {
              const newKey = `${formattedKey} ${index + 1}`;
              propertyObject[newKey] = frameCode;
            });

          } else {
            propertyObject[formattedKey] = value;
          }
        }
      }
      return propertyObject;
    },
  },
  methods: {
    transformText(key) {
      let formattedKey = key
        .split("_")
        .map((part) => part[0].toUpperCase() + part.substring(1))
        .join(" ");
      if (formattedKey === "Bed Size") return "Size";
      if (formattedKey === "Orientation" && this.productType === "Chaise")
        return "Chaise Facing";
      if (formattedKey === "Orientation" && this.productType === "Sectional")
        return "Corner On";
      if (
        formattedKey === "Orientation" &&
        this.productType === "Sectional with Bumper"
      )
        return "Bumper";
      if (
        formattedKey === "Orientation" &&
        this.productType === "Sofa with Bumper"
      )
        return "Bumper Orientation";
      if (
        formattedKey === "Orientation" &&
        this.productType === "Sofa with Chaise"
      )
        return "Chaise";
      return formattedKey;
    },
    deriveSizeField(productFields) {
      const fieldValues = [];
      for (const field of productFields) {
        const fieldValue = this.activeProduct[field]
        if (fieldValue) {
          if (isNaN(fieldValue)) {
            fieldValues.push(`${fieldValue}`);
          } else {
            fieldValues.push(`${fieldValue}"`)
          }
        }
      }
      if (fieldValues.length === 1) {
        return fieldValues[0];
      }
      return fieldValues.join(" x ");
    },
  },
};
</script>
<style scoped>
.selected-wrapper {
    margin-bottom: 20px;
}
.selected-heading {
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  margin-bottom: 10px;
}
.selected-value {
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 6px;
}
@media screen and (min-width: 1024px) {
  .selected-heading {
    font-size: 20px;
  }
  .selected-value {
    font-size: 18px;
  }
}
</style>
